import enTables from './en/Tables';
import ruTables from './ru/Tables';
import enUpdates from './en/Updates';
import ruUpdates from './ru/Updates';

export default {
    en: {
        translation: {
            tables: enTables,
            updates: enUpdates,
        }
    },
    ru: {
        translation: {
            tables: ruTables,
            updates: ruUpdates,
        }
    }
};
